if (!customElements.get("ff-alohas-color-swatches")) {
  class FfAlohasColorSwatches extends HTMLElement {
    constructor () {
      super();

      this.style.display = "block";

      if (this.dataset.swatchesMiniatures) {
        return;
      }

      const swiperParams = {
        autoplay: false,
        mousewheel: {
          forceToAxis: true,
        },
        spaceBetween: 2,
        freeMode: true,
        slidesPerView: "auto",
        navigation: {
          nextEl: '.ff-alohas-color-swatches-arrow-button-next',
          prevEl: '.ff-alohas-color-swatches-arrow-button-prev',
        },
      }

      const swiper = new Swiper(".ff-alohas-color-swatches-swiper", swiperParams);

      swiper.update()

      if (swiper.isLocked) {
        this.querySelector(".ff-alohas-color-swatches-navigation").remove();
      }
    }
  }
  customElements.define("ff-alohas-color-swatches", FfAlohasColorSwatches)
}

/** DATA LAYER COLOR SELECTION **/
document.addEventListener('click', function(event) {
  const colorElement = event.target.closest(
    '.ff-alohas-color-swatches-swiper .ff-alohas-color-swatches-miniature, ' +
    '.ff-alohas-color-swatches-swiper .ff-alohas-color-swatches-color, ' +
    '.ff-alohas-color-swatches-grid .ff-alohas-color-swatches-miniature'
  );

  if (!colorElement) return;

  var dataLayer = window.dataLayer || [];

  const container = colorElement.closest('ff-alohas-color-swatches');
  const activeElement = container ? container.querySelector('.ff-alohas-color-swatches-active-miniature') : null;

  const previousColor = activeElement ? (activeElement.getAttribute('data-color') || 'none') : 'none';
  const selectedColor = colorElement.getAttribute('data-color') || 'none';
  const itemName = colorElement.getAttribute('data-style') || 'none';

  dataLayer.push({
    'event': 'color_selection',
    'previous_color': previousColor,
    'selected_color': selectedColor,
    'item_name': itemName
  });
});